import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApacheComponent } from './simple-icons-apache.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApacheComponent ],
    exports:      [ SimpleIconsApacheComponent ],
    bootstrap:    []
})
export class SimpleIconsApacheModule {}
